import React from 'react';
import { CommonWrapper } from 'screens/MortgageOfficePage/styled';
import FbIcon from 'assets/svg/fb.svg';
import InIcon from 'assets/svg/linkedin-small.svg';
import WebIcon from 'assets/svg/web.svg';
import InstagramIcon from 'assets/svg/instagram.svg';
import * as Styled from './styled';
import { useLocale } from 'locale';

type PropsKey = 'web' | 'fb' | 'instagram' | 'lIn';


export const SocialRow: React.FC<Record<PropsKey, string>> = ({ web, fb, instagram, lIn }) => {
  const { t } = useLocale();

  return (
    <Styled.Wrapper>
      <CommonWrapper>
        <Styled.Title weight="bold">{t('mortgage.officePage.social.title')}</Styled.Title>
        {web ? <Styled.Social href={web} rel="nofollow" target="_blank" skipFill><WebIcon /></Styled.Social> : null}
        {fb ? <Styled.Social href={fb} rel="nofollow" target="_blank"><FbIcon /></Styled.Social> : null}
        {instagram ? <Styled.Social href={instagram} rel="nofollow" target="_blank"><InstagramIcon /></Styled.Social> : null}
        {lIn ? <Styled.Social href={lIn} rel="nofollow" target="_blank"><InIcon /></Styled.Social> : null}
      </CommonWrapper>
    </Styled.Wrapper>
  );
};
